/**
 * Lazy Loading helper
 *
 * Usage:
 *
 * // in model
 *  this.lazyLoader = LazyLoaderFactory({
 *      onLoad: function() {
 *          // .. load data
 *
 *
 *          // when no more events
 *          this.lazyLoader.stop();
 *
 *          return [promise];
 *      }
 *  });
 *
 *  // in view
 *  this.model.lazyLoader.start(el);
 */

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var Template = require('class/template.class');

    var lazyLoadFactory = function(options) {
        var scrollingElement = null;
        var $scrollingElement = null;
        var eventsBound = false;
        var isLoading = false;
        var hasBeenStopped = false;
        var $loader;

        /**
         * Should be overridden
         * @returns {*}
         */
        var onLoad = function() {
            var state = $.Deferred();

            return state.promise();
        };

        function init(opts) {
            if (opts && opts.onLoad) {
                onLoad = opts.onLoad;
            }
        }

        function listenToElement(el) {
            setScrollingElement(el);
            bindEvents();
        }

        function setScrollingElement(el) {
            scrollingElement = el;
            $scrollingElement = $(el);
        }

        function handleScrolling(e) {
            if (isLazyLoadPositionReached(e)) {
                loadData();
            }
        }

        function isLazyLoadPositionReached(e) {
            var sizes = e.target.getBoundingClientRect();

            return sizes.bottom < window.innerHeight;
        }

        function bindEvents() {
            if ($scrollingElement.length && !eventsBound) {
                $scrollingElement.on('scroll.lazyLoad', _.throttle(handleScrolling, 100));
                eventsBound = true;
            }
        }

        function unbindEvents() {
            $scrollingElement && $scrollingElement.off('scroll.lazyLoad');
            eventsBound = false;
        }

        function appendLoaderAndScroll() {
            var template = new Template('common.loader');
            $loader = $(template.getNodes());
            $scrollingElement.append($loader);
            scrollingElement.scrollTop = scrollingElement.scrollHeight - scrollingElement.clientHeight;
        }

        function removeLoader() {
            $loader.remove();
        }

        function loadData() {
            if (isLoading) {
                return;
            }

            appendLoaderAndScroll();
            isLoading = true;

            onLoad()
                .always(function() {
                    removeLoader();
                    isLoading = false;
                });
        }

        function stop() {
            unbindEvents();
            hasBeenStopped = true;
        }

        function isStarted() {
            return eventsBound;
        }

        function isStopped() {
            return hasBeenStopped;
        }

        init(options);

        return {
            start: listenToElement,
            stop: stop,
            isStarted: isStarted,
            isStopped: isStopped
        };
    };

    return lazyLoadFactory;
});
